import React from "react";
import "./GrievanceRedressalCommitteeSCST.css";
import Section from "../../../HomePage/Section/Section";
import Navbar from "../../../HomePage/navbar/Navbar";
import Footer from "../../../HomePage/Footer/Footer";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUserShield,
  faPhone,
  faExternalLinkAlt,
  faGraduationCap,
  faBriefcase,
} from "@fortawesome/free-solid-svg-icons";
import "../../../../App.css";

const members = [
  {
    name: "Dr.R.Viswanathan (Dean S&H)",
    role: "Chairman",
    mobile: "9715814284",
  },
  { name: "Dr.K.Prabu (Physics)", role: "Member", mobile: "9095171720" },
  { name: "Dr.R.Ramyasri (English)", role: "Member", mobile: "8012617387" },
  {
    name: "Mr.K.V.Satheesh Kumar (Mechanical)",
    role: "Member",
    mobile: "6383219802",
  },
  { name: "Mr.P.Karthikeyan (EEE)", role: "Member", mobile: "9976466438" },
  {
    name: "Ms.K.K.Sri Mohana Priya (FT)",
    role: "Member",
    mobile: "9524245729",
  },
  { name: "Ms.M.Kannukkiniyal (CSE)", role: "Member", mobile: "6374088547" },
];

const GrievanceRedressalCommitteeSCST = () => {
  return (
    <>
      {/* <Section/> */}
      <Navbar />
      <div className="scst-container">
        <h1 className="page-title">
          Grievance Redressal & Empowerment Committee for SC/ST
        </h1>
        <div className="cards">
          {members.map((member, index) => (
            <div className="card" key={index}>
              <FontAwesomeIcon icon={faUserShield} className="profile1-icon" />
              <h3 className="gre_name">{member.name}</h3>
              <p className="role1">{member.role}</p>
              <p className="mobile">
                <FontAwesomeIcon icon={faPhone} /> {member.mobile}
              </p>
            </div>
          ))}
        </div>

        <div className="objectives">
          <h2>Objectives</h2>
          <ul>
            <li>To enhance the employability of SC/ST students</li>
            <li>To redress the grievances / complaints of SC/ST students</li>
            <li>To provide counseling services to SC/ST students</li>
            <li>To redress the grievances / complaints of SC/ST employees</li>
          </ul>
        </div>

        <div className="scst-registration">
          <h2>Student & Employee Registration Form</h2>
          <div className="registration-links">
            <a
              href="https://forms.gle/4f4bfmBXCwznmaXM6"
              target="_blank"
              rel="noopener noreferrer"
              className="registration-card"
            >
              <div className="reg-icon-wrapper">
                <FontAwesomeIcon icon={faBriefcase} />
              </div>
              <div className="reg-info">
                <h3>Employee Registration Form</h3>
                <p>Click here to fill out the online registration form for SC/ST Employees</p>
              </div>
              <div className="reg-action">
                <span>Submit the Form</span>
                <FontAwesomeIcon icon={faExternalLinkAlt} />
              </div>
            </a>

            <a
              href="https://forms.gle/SwCTUt4uZfMbkEtCA"
              target="_blank"
              rel="noopener noreferrer"
              className="registration-card"
            >
              <div className="reg-icon-wrapper">
                <FontAwesomeIcon icon={faGraduationCap} />
              </div>
              <div className="reg-info">
                <h3>Student Registration Form</h3>
                <p>Click here to fill out the online registration form for SC/ST Students</p>
              </div>
              <div className="reg-action">
                <span>Submit the Form</span>
                <FontAwesomeIcon icon={faExternalLinkAlt} />
              </div>
            </a>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default GrievanceRedressalCommitteeSCST;
